<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10">
    <path
      d="M5.697.3c.193.193.3.452.303.73a.998.998 0 0 1-.303.756L2.494 5l3.203 3.213c.193.193.3.453.303.73v.01c0 .279-.107.542-.3.743-.388.404-1.041.407-1.46.003L.304 5.737a1.026 1.026 0 0 1-.301-.72C-.001 4.98 0 4.982 0 4.965c0-.258.106-.506.303-.703L4.253.3c.398-.4 1.046-.4 1.444 0"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
